import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

const AdminLoginGuard = () => {
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		setIsAuthenticated(true);
	}, []);

	return isAuthenticated && <Outlet />;
};

export default AdminLoginGuard;
